import { QuestionProps } from '../Questions/Props';

/**
 * 
 * @todo this has not yet been implemented in TS
 */
export function QuotaCheck(props: QuestionProps & { block: JSX.Element}) {
  return props.block;
}
